import moment from 'moment'
import { Maybe } from 'types/FMSGraphqlTypes'

export const getRemainingTimeInMinutes = (expiresAt: Maybe<string>) => {
  if (!expiresAt) {
    return 0
  }
  const expirationDate = moment(expiresAt)
  const currentTime = moment.utc()
  return expirationDate.diff(currentTime, 'minutes')
}
